// Tracks the last Permissions-Version response header the client has
// successfully synced permissions for. The axios interceptor reads it to detect
// changes and dispatches `permissions-version-changed`; usePermissionRefresh
// commits the new value only after its CheckIn refetch succeeds, so a transient
// refresh failure retriggers on the next response instead of leaving
// permissions stale forever.
let lastPermissionsVersion: string | null = null

export const getPermissionsVersion = () => lastPermissionsVersion

export const commitPermissionsVersion = (version: string) => {
  lastPermissionsVersion = version
}

export const resetPermissionsVersion = () => {
  lastPermissionsVersion = null
}
